module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/public-page/main-menu/university-info-dialog/edit/university-info-edit.component.scss
// module id = ./src/app/modules/admin/components/public-page/main-menu/university-info-dialog/edit/university-info-edit.component.scss
// module chunks = main